import React from 'react'
import PropTypes from 'prop-types'
import TransitionLink from 'gatsby-plugin-transition-link'

import ProgressBar from '../../ProgressBar'
import { resolveWordPressPathForGatsby } from '../../../utils'
import './Slide.css'

const Slide = ({ datas }) => {
  if (!datas) {
    return null
  }

  const { featured_media, id, path, title } = datas
  const safeTitle = title || ''
  const linkTo = resolveWordPressPathForGatsby(path)

  return (
    <div className="slide">
      <div className="holder">
        <div className="container">
          <div className="slide__caption">
            <h2 aria-label={safeTitle} className="slide__title" data-splitting>{safeTitle}</h2>
          </div>
        </div>
        {featured_media && featured_media.source_url && (
          <picture>
            <source data-srcset={featured_media.source_url} />
            <img
              src={featured_media.source_url}
              className="slide__img lazyload"
              alt={featured_media.alt_text || safeTitle || ''}
            />
          </picture>
        )}
        <TransitionLink
          className="slide__link"
          data-splitting
          exit={{
            length: .9,
          }}
          entry={{
            delay: .9,
          }}
          state={{
            index: id,
          }}
          title="Voir le détail du projet"
          to={linkTo}
        >
          Découvrir le projet
        </TransitionLink>
      </div>
      <ProgressBar />
    </div>
  )
}

Slide.propTypes = {
  datas: PropTypes.object.isRequired,
}

export default Slide
